import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AxelInput from "../../../UI/AxelInput";
import AxelCheckbox from "../../../UI/AxelCheckbox";
import { useLazyGetProcurementPackageQuery } from "../../../store/service/procurement";
import { useCreateUsersMutation, useUpdateUsersMutation } from "../../../store/service/adbService";
import { errorHandle } from "../../../global/errorHandle";
import { setLoader } from "../../../store/slice/dashboard";

const CreateUser3 = () => {
    const { id: userId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isCreateUserPage = location.pathname === "/create-user/step-3";
    const storageKey = isCreateUserPage ? "create-user" : "edit-user";
    const storedData = JSON.parse(localStorage.getItem(storageKey)) || {};

    const [searchText, setSearchText] = useState("");
    const [allSelected, setAllSelected] = useState(false);
    const [selectedPackages, setSelectedPackages] = useState(storedData?.packages || []);
    const [packages, setPackages] = useState([]);

    const [getAllPackages] = useLazyGetProcurementPackageQuery();
    // const [createUsers, { isSuccess: isCreateSuccess, isError: isCreateError, error: createError }] =
    //     useCreateUsersMutation();
    // const [updateUsers, { isSuccess: isUpdateSuccess, isError: isUpdateError, error: updateError }] =
    //     useUpdateUsersMutation();

    useEffect(() => {
        getAllPackages({ per_page: 1000, page: 1 }).then(({ data }) => {
            setPackages(data?.data?.data || []);
        });
    }, [getAllPackages]);

    // useEffect(() => {
    //     // Needed fixing
    //     if (isCreateSuccess) {
    //         toast.success("User created successfully!");
    //         localStorage.removeItem(storageKey);
    //         navigate('/secondary-pages/users')
    //     }
    //     if (isUpdateSuccess) {
    //         toast.success("User updated successfully!");
    //         localStorage.removeItem(storageKey);
    //         navigate('/secondary-pages/users')
    //     }
    //
    // }, [isCreateSuccess, isUpdateSuccess]);

    // useEffect(() => {
    //     if (isCreateError) errorHandle(createError);
    //     if (isUpdateError) errorHandle(updateError);
    //     dispatch(setLoader(false));
    // }, [ isCreateError, isUpdateError, createError, updateError]);
    //
    // useEffect(() => {
    //     dispatch(setLoader(isCreateSuccess || isUpdateSuccess));
    // }, [isCreateSuccess, isUpdateSuccess, dispatch]);

    useEffect(() => {
        setAllSelected(selectedPackages.length === packages.length);
    }, [selectedPackages, packages]);

    const handleSelectAll = (isSelected) => {
        setAllSelected(isSelected);
        setSelectedPackages(isSelected ? packages.map((pkg) => pkg.id) : []);
    };

    const handleSelection = (packageId) => {
        setSelectedPackages((prevSelected) =>
            prevSelected.includes(packageId)
                ? prevSelected.filter((id) => id !== packageId)
                : [...prevSelected, packageId]
        );
    };

    const filteredPackages = packages.filter((pkg) =>
        pkg.title?.toLowerCase().includes(searchText.toLowerCase())
    );

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     const formData = { packages: selectedPackages };
    //     dispatch(setLoader(true));
    //     if (userId) {
    //         updateUsers({ id: userId, body: {
    //             ...storedData,
    //                 ...formData } });
    //     } else {
    //         createUsers({ ...storedData, ...formData });
    //     }
    //
    // };

    const navigateToPreviousStep = (e) => {
        e.preventDefault();
        navigate(isCreateUserPage ? "/create-user/step-2" : `/edit-user/${userId}/step-2`);
    };

    return (
        <form className="create__form" >
            <div className="create__form-content">
                <AxelInput
                    className="nSettings__copySettings__search searchProject"
                    src="/assets/icons/search.svg"
                    placeholder="Search..."
                    value={searchText}
                    handler={(e) => setSearchText(e.target.value)}
                />
                <div className="contact__modal-projectBox">
                    <AxelCheckbox
                        id="all-packages"
                        checked={allSelected}
                        handler={(e, isChecked) => handleSelectAll(isChecked)}
                    />
                    <label htmlFor="all-packages">Select all packages</label>
                </div>
                {filteredPackages.map((pkg) => (
                    <div key={pkg.id} className="contact__modal-projectBox">
                        <AxelCheckbox
                            id={`package-${pkg.id}`}
                            checked={selectedPackages.includes(pkg.id)}
                            handler={() => handleSelection(pkg.id)}
                        />
                        <label htmlFor={`package-${pkg.id}`}>{pkg.title}</label>
                    </div>
                ))}
            </div>
            <div className="create__form-btns">
                <button
                    type="button"
                    onClick={navigateToPreviousStep}
                    className="create__form-back"
                >
                    Back
                </button>
                <button type="submit" className="create__form-next">
                    <span>Save</span>
                    <span>
                        <img src="/assets/icons/next-icon.svg" alt="icon" />
                    </span>
                </button>
            </div>
        </form>
    );
};

export default CreateUser3;
